/*
 * @Author: linbin@leedarson.com
 * @Date: 2022-11-30 09:22:42
 * Copyright © Leedarson. All rights reserved.
 */

import { getCurrentToken } from '@root/shared/currentAuth';
import {
  getLocalStorageRecord,
  removeLocalStorageRecord,
  setLocalStorageRecord,
} from './localStorageRecord';
import { ILogRecord } from './types';

// const getDeveloperLogServer = () => {
//   const { hostname } = window.location;
//   const [_, serverEnv, region] = hostname.match(/^(\w+)-(\w+)/) || [];
//   if (serverEnv) {
//     // 生产环境 https://us-payment.aidot.com
//     if (['eu', 'us'].includes(serverEnv.toLowerCase())) {
//       return `https://prod-${serverEnv}-log.arnoo.com/logs/reportLog`;
//     }
//     return `https://${serverEnv}-${region}-log.arnoo.com/logs/reportLog`;
//   }

//   return null;
// };

const getDeveloperLogServer = () => {
  const { REACT_APP_SERVER_ENV, REACT_APP_REGION } = process.env;
  return `https://${REACT_APP_SERVER_ENV}-${REACT_APP_REGION}-log.arnoo.com/logs/reportLog`;
};

const _upload = async (data: any) => {
  try {
    const server = getDeveloperLogServer();
    const accessToken = getCurrentToken();
    if (!server || !accessToken) {
      return Promise.reject({ code: 401, desc: `没有登陆 || 没有云端地址` });
    }
    const formData = new FormData();
    const value = JSON.stringify({
      contents: Array.isArray(data) ? data : [data],
    });
    formData.append('data', value);
    const response = await fetch(server, {
      headers: {
        // 注意：不能设置`'Content-Type': 'multipart/form-data'`，因为`boundary`分割值不确定
        // content-type: multipart/form-data; boundary=----WebKitFormBoundaryomrZWdulUtDQxbng
        token: accessToken,
      },
      method: 'POST',
      body: formData,
    });
    const result = await response.json();
    if (response.ok) {
      return result;
    }
    return Promise.reject({ ...result, desc: '令牌过期 || 云端报错' });
  } catch (error: any) {
    console.error('upload catch', error);
    return Promise.reject({ code: 400, desc: '上传异常', data: error });
  }
};

let timer: any;
const upload = (record: ILogRecord) => {
  if (!timer) {
    // 无定时，延迟上传
    setLocalStorageRecord(record);
    timer = setTimeout(async () => {
      timer = null;
      const records = getLocalStorageRecord(); // 一定存在数据，所以不用判空
      removeLocalStorageRecord();
      try {
        await _upload(records);
      } catch (error) {
        setLocalStorageRecord(records);
      }
    }, 3000);
  } else {
    // 有定时，节流上传
    setLocalStorageRecord(record);
  }
};

export default upload;
